export default {
  init() {
    // JavaScript to be fired on the blog page
    $(document).ready(function() {
      $('.questions-question').on('click', function() {
        if($(this).hasClass('active')){
          $('.questions-image').css({'opacity': '1'});
          $(this).removeClass('active');
           $(this).parent().children('.questions-answer').removeClass('active');
        } else {
          $('.questions-image').css({'opacity': '0'});
          $('.questions-question').removeClass('active');
          $('.questions-answer').removeClass('active');
          $(this).addClass('active');
          $(this).parent().children('.questions-answer').addClass('active');
        }
      });
    });
  },
};
